import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card, PageHeader } from "../components/UI";
import { ScrollText } from "lucide-react";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/audit/logs?limit=300"); setLogs(data); })(); }, []);

  return (
    <div className="p-6 lg:p-8 space-y-6">
      <PageHeader eyebrow="Compliance" title="Audit Logs" subtitle="Every create, update, approval, and AI action is recorded for compliance and forensics." />
      <Card padded={false}>
        <div className="overflow-x-auto max-h-[640px] overflow-y-auto">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead className="sticky top-0 bg-app">
              <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-white/10">
                <th className="px-5 py-3">Time</th>
                <th className="px-5 py-3">User</th>
                <th className="px-5 py-3">Action</th>
                <th className="px-5 py-3">Entity</th>
                <th className="px-5 py-3">Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                  <td className="px-5 py-2 text-xs font-mono text-slate-400">{new Date(l.timestamp).toLocaleString()}</td>
                  <td className="px-5 py-2 text-slate-300">{l.user_email || "system"}</td>
                  <td className="px-5 py-2"><span className="text-cyan-300 uppercase text-[10px] tracking-wider">{l.action}</span></td>
                  <td className="px-5 py-2 text-slate-300">{l.entity_type} <span className="text-slate-500 text-xs">{l.entity_id?.substring(0, 8)}</span></td>
                  <td className="px-5 py-2 text-xs text-slate-400 font-mono truncate max-w-md">{l.details ? JSON.stringify(l.details).substring(0, 80) : "—"}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan="5" className="text-center py-10 text-slate-500">No activity yet</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
